import { VisibilityOff } from "@mui/icons-material";
import {
  GlobalStyles,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { ChangeEvent, ReactNode, useState } from "react";
import theme from "../../theme";
import {
  PasswordEyeIcon,
  PasswordEyeIconOff,
} from "../../assets/Icon/singUpIcon";
interface InputProps {
  placeholder: string;
  icon?: ReactNode;
  type?: string;
  minWidth: string;
  formik?: any;
  margin?: "dense" | "normal" | "none";
  name?: string;
}
const InputField: React.FC<InputProps> = ({
  placeholder,
  icon,
  type,
  name,
  minWidth,
  formik,
  margin,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let value = e.target.value;
    formik?.setFieldValue(name, value);
  };

  return (
    <>
      <TextField
        type={type === "password" && !showPassword ? "password" : "text"}
        placeholder={placeholder}
        size="medium"
        margin={margin}
        onChange={(e) => handleChange(e)}
        value={formik?.values[name ?? ""]}
        error={!!(formik?.errors[name ?? ""] && formik?.touched[name ?? ""])}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">{icon}</InputAdornment>
            ),
            endAdornment: type === "password" && (
              <InputAdornment position="end">
                <IconButton onClick={handleTogglePassword} edge="end">
                  {showPassword ? <PasswordEyeIcon /> : <PasswordEyeIconOff />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        sx={{
          // maxWidth: "100%",
          maxWidth: "450px",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "1px solid transparent", // Default state, no border
            },
            "&:hover fieldset": {
              border: "none", // Border on hover
            },
            "&.Mui-focused fieldset": {
              border: "0.5px solid #A7C7EA", // Border when focused
            },
            "& .MuiOutlinedInput-input": {
              minWidth: type === "password" ? "353px" : "389px", // Default width
              //   [theme.breakpoints.down("md")]: {
              //     minWidth: type === "password" ? "300px" : "340px", // Medium screens
              //   },
              [theme.breakpoints.down("sm")]: {
                minWidth: type === "password" ? "180px" : "240px", // Small screens
              },
              "@media (max-width: 320px)": {
                minWidth: type === "password" ? "150px" : "200px", // Very small screens (320px and below)
              },
            },
          },
        }}
      />

      {/* <Typography
        variant="h5"
        style={{
          color: "red",
          fontWeight: "400",
          textAlign: "left",
          padding: "0px 0px 20px 0px",
        }}
      > */}

      <div
        className="break-word"
        // variant="body2" // Use body2 for smaller text
        style={{
          color: "red",
          fontWeight: "400",
          textAlign: "left",
          padding: "0px 0px 20px 0px",
          wordWrap: "break-word", // Allow text to wrap within the container
          overflowWrap: "break-word",
          width: "60%", // Ensure wrapping occurs properly
        }}
      >
        {formik?.errors[name ?? ""] &&
          formik?.touched[name ?? ""] &&
          formik?.errors[name ?? ""]}
      </div>
    </>
  );
};

export default InputField;
